import Avatar from '@mui/material/Avatar';
import {memo} from 'react';

const MUIAvatar = (props: any): any => {
    const {children, ...rest} = props;
    return (
        <Avatar src={props.src} alt={props.alt} variant={props.variant} className={props.className} {...rest}>
            {children}
        </Avatar>
    );
};

export default memo(MUIAvatar);
